import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const AnnouncementsModal = ({ show, onHide, announcements, isDarkMode }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={isDarkMode ? 'dark-mode' : ''}
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: isDarkMode ? '1px solid #495057' : '1px solid #dee2e6',
          backgroundColor: isDarkMode ? '#212529' : '#fff',
          color: isDarkMode ? '#fff' : '#000'
        }}
      >
        <Modal.Title>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '24px' }}>📢</span>
            <span>Announcements</span>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          backgroundColor: isDarkMode ? '#212529' : '#fff',
          color: isDarkMode ? '#fff' : '#000',
          padding: '24px'
        }}
      >
        <div
          style={{
            background: isDarkMode
              ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 51, 234, 0.1) 100%)'
              : 'linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(147, 51, 234, 0.05) 100%)',
            border: '2px solid #3b82f6',
            borderRadius: '12px',
            padding: '20px'
          }}
        >
          <div style={{
            fontSize: '15px',
            color: isDarkMode ? '#cbd5e1' : '#475569',
            lineHeight: '1.6',
            whiteSpace: 'pre-wrap'
          }}>
            {announcements || 'No announcements at this time.'}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer
        style={{
          borderTop: isDarkMode ? '1px solid #495057' : '1px solid #dee2e6',
          backgroundColor: isDarkMode ? '#212529' : '#fff'
        }}
      >
        <Button variant="primary" onClick={onHide}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AnnouncementsModal;
